export default __webpack_public_path__ + "238ed670a983b6e41caa868ba75d419a.svg";